(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["leaf-shared-advisor"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('leaf-guided-advisor')) {
  customElements.define('leaf-guided-advisor', class extends HTMLElement {
    async connectedCallback() {
      if (this.dataset.ready) return;
      this.dataset.ready = 'true';
      this.homeMode = this.dataset.homeMode === 'true';
      this.rows = Array.from(this.querySelectorAll('[data-advisor-product]')).map((node) => ({
        title: node.dataset.title || '',
        url: node.dataset.url || '',
        price: node.dataset.price || '',
        priceSort: Number(node.dataset.priceSort || 0),
        image: node.dataset.image || '',
        imageAlt: node.dataset.imageAlt || node.dataset.title || '',
        world: node.dataset.world || '',
        worldLabel: node.dataset.worldLabel || node.dataset.world || '',
        need: node.dataset.needs || '',
        context: node.dataset.contexts || '',
        preference: node.dataset.preferences || ''
      }));
      this.state = {
        world: this.homeMode ? '' : (this.dataset.collection || ''),
        need: '',
        context: '',
        preference: ''
      };
      this.groupOrder = [];
      this.optionSets = {};
      this.steps = [];
      this.remoteResults = [];
      this.index = 0;
      this.restoreLocal();
      this.bind();
      await this.restoreRemote();
      await this.refreshAdvisor();
    }

    isProjectCode(value) {
      return /^[0-9a-f]{8}-[0-9a-f]{4}-4[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i.test(String(value || ''));
    }

    async refreshAdvisor() {
      const requestId = (this.requestId || 0) + 1;
      this.requestId = requestId;
      this.requestController?.abort();
      const controller = new AbortController();
      this.requestController = controller;
      const timeout = setTimeout(() => controller.abort(), 10000);
      const activeStep = this.pendingStep || this.steps[this.index];
      this.pendingStep = '';
      const status = this.querySelector('[data-service-status]');
      if (status) status.textContent = this.dataset.loadingLabel || '';
      this.pending = true;
      this.querySelectorAll('[data-next], [data-back], [data-option-group]').forEach(button => { button.disabled = true; });
      try {
        const response = await fetch(this.dataset.advisorEndpoint, {
          method: 'POST', credentials: 'omit', signal: controller.signal,
          headers: { 'content-type': 'application/json', apikey: this.dataset.advisorKey, authorization: 'Bearer ' + this.dataset.advisorKey },
          body: JSON.stringify({ rows: this.rows, selected: this.state, homeMode: this.homeMode, collection: this.dataset.collection || '' })
        });
        if (!response.ok) throw new Error('advisor_unavailable');
        const payload = await response.json();
        if (requestId !== this.requestId) return;
        if (!Array.isArray(payload.steps) || !Array.isArray(payload.results)) throw new Error('invalid_advisor_response');
        this.state = payload.selected;
        this.optionSets = payload.options;
        this.groupOrder = payload.groupOrder;
        this.steps = payload.steps;
        this.remoteResults = payload.results;
        this.selectionCount = payload.selectionCount;
        this.index = Math.max(0, this.steps.indexOf(activeStep));
        Object.entries(this.optionSets).forEach(([group, options]) => this.buildOptions(group, options));
        this.saveLocal();
        if (status) status.textContent = '';
        this.update();
      } catch {
        if (requestId !== this.requestId) return;
        this.remoteResults = [];
        this.renderResults();
        if (status) status.textContent = this.dataset.unavailableLabel || '';
      } finally {
        clearTimeout(timeout);
        if (requestId === this.requestId) {
          this.pending = false;
          this.querySelectorAll('[data-next], [data-back], [data-option-group]').forEach(button => { button.disabled = false; });
        }
      }
    }

    buildOptions(group, options) {
      const host = this.querySelector('[data-options="' + group + '"]');
      if (!host) return;
      host.replaceChildren();
      options.forEach((item) => {
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'leaf-advisor__option';
        button.dataset.optionGroup = group;
        button.dataset.optionValue = item.value;
        button.setAttribute('aria-pressed', 'false');
        button.textContent = item.label;
        host.append(button);
      });
    }

    displayValue(group, value) {
      const item = this.optionSets[group]?.find((option) => option.value === value);
      return item?.label || value;
    }

    bind() {
      this.addEventListener('click', async (event) => {
        const option = event.target.closest('[data-option-group]');
        if (option) {
          const group = option.dataset.optionGroup;
          const value = option.dataset.optionValue || '';
          this.state[group] = this.state[group] === value ? '' : value;

          this.saveLocal();
          this.markRemoteDirty();
          this.updateOptions();
          this.updateSummary();
          await this.refreshAdvisor();
          return;
        }

        if (event.target.closest('[data-next]')) {
          if (this.index < this.steps.length - 1) this.index += 1;
          this.update();
          return;
        }

        if (event.target.closest('[data-back]')) {
          if (this.index > 0) this.index -= 1;
          this.update();
          return;
        }

        if (event.target.closest('[data-reset]')) {
          this.state = {
            world: this.homeMode ? '' : (this.dataset.collection || ''),
            need: '',
            context: '',
            preference: ''
          };

          this.index = 0;
          this.saveLocal();
          this.markRemoteDirty();
          await this.refreshAdvisor();
          return;
        }

        const saveButton = event.target.closest('[data-save-project]');
        if (saveButton) {
          this.saveRemote(saveButton);
          return;
        }

        if (event.target.closest('[data-copy-project-link]')) {
          this.copyProjectLink();
        }
      });
    }

    readStored() {
      try {
        return JSON.parse(localStorage.getItem(this.dataset.storageKey) || '{}') || {};
      } catch {
        return {};
      }
    }

    applySelection(selected) {
      const input = selected && typeof selected === 'object' ? selected : {};
      ['world', 'need', 'context', 'preference'].forEach(group => {
        this.state[group] = typeof input[group] === 'string' ? input[group] : '';
      });
    }

    restoreLocal() {
      const stored = this.readStored();
      this.applySelection(stored.selected || {});
      if (this.isProjectCode(stored.projectCode)) this.projectCode = stored.projectCode;

      if (Object.values(this.state).some(Boolean)) this.showResume();
    }

    async restoreRemote() {
      const endpoint = this.dataset.projectEndpoint;
      if (!endpoint) return;
      let urlCode = '';
      try {
        urlCode = new URL(window.location.href).searchParams.get(this.dataset.projectParam || 'leaf_project') || '';
      } catch {}
      const code = this.isProjectCode(urlCode) ? urlCode : (this.isProjectCode(this.projectCode) ? this.projectCode : '');
      if (!code) return;

      try {
        const response = await fetch(endpoint + '?code=' + encodeURIComponent(code), {
          method: 'GET',
          headers: { accept: 'application/json' },
          credentials: 'omit'
        });
        if (!response.ok) return;
        const payload = await response.json();
        this.projectCode = payload.code || code;
        this.applySelection(payload.selected || {});
        this.pendingStep = String(payload.step || '');
        this.saveLocal();
        this.showResume();
        this.showProjectControls();
        this.setProjectStatus(this.dataset.restoredLabel || '');
      } catch {}
    }

    saveLocal() {
      try {
        localStorage.setItem(this.dataset.storageKey, JSON.stringify({
          selected: this.state,
          collection: this.state.world || this.dataset.collection || '',
          projectCode: this.projectCode || '',
          updatedAt: Date.now()
        }));
      } catch {}
    }

    async saveRemote(button) {
      const endpoint = this.dataset.projectEndpoint;
      if (!endpoint || typeof crypto?.randomUUID !== 'function') {
        this.setProjectStatus(this.dataset.saveErrorLabel || '');
        return;
      }

      const originalLabel = button.textContent;
      button.disabled = true;
      button.textContent = this.dataset.savingLabel || originalLabel;
      try {
        const code = this.isProjectCode(this.projectCode) ? this.projectCode : crypto.randomUUID();
        const activeStep = this.steps[this.index] || (this.homeMode ? 'world' : 'need');
        const response = await fetch(endpoint, {
          method: 'POST',
          credentials: 'omit',
          headers: { 'content-type': 'application/json' },
          body: JSON.stringify({
            resume_code: code,
            selected: this.state,
            collection: this.state.world || this.dataset.collection || '',
            step: activeStep
          })
        });
        if (!response.ok) throw new Error('save_failed');
        const payload = await response.json();
        this.projectCode = payload.code || code;
        this.saveLocal();

        const url = new URL(window.location.href);
        url.searchParams.set(this.dataset.projectParam || 'leaf_project', this.projectCode);
        history.replaceState(null, '', url.toString());

        this.showResume();
        this.showProjectControls();
        this.setProjectStatus(this.dataset.savedLabel || '');
      } catch {
        this.setProjectStatus(this.dataset.saveErrorLabel || '');
      } finally {
        button.disabled = false;
        button.textContent = this.dataset.saveLabel || originalLabel;
      }
    }

    async copyProjectLink() {
      if (!this.isProjectCode(this.projectCode)) return;
      const url = new URL(window.location.href);
      url.searchParams.set(this.dataset.projectParam || 'leaf_project', this.projectCode);
      try {
        await navigator.clipboard.writeText(url.toString());
        this.setProjectStatus(this.dataset.copiedLabel || '');
      } catch {
        this.setProjectStatus(url.toString());
      }
    }

    showResume() {
      const resume = this.querySelector('[data-resume]');
      if (resume) resume.hidden = false;
    }

    showProjectControls() {
      const copy = this.querySelector('[data-copy-project-link]');
      if (copy) copy.hidden = !this.isProjectCode(this.projectCode);
    }

    setProjectStatus(value) {
      const status = this.querySelector('[data-project-status]');
      if (status) status.textContent = value || '';
    }

    markRemoteDirty() {
      if (this.isProjectCode(this.projectCode)) this.setProjectStatus(this.dataset.unsavedLabel || '');
    }

    updateOptions() {
      this.querySelectorAll('[data-option-group]').forEach((button) => {
        const group = button.dataset.optionGroup;
        button.setAttribute('aria-pressed', String(this.state[group] === button.dataset.optionValue));
      });
    }

    updateSummary() {
      const selected = this.groupOrder
        .filter((group) => this.state[group])
        .map((group) => this.displayValue(group, this.state[group]));
      const progressSummary = this.querySelector('[data-selection-summary]');
      if (progressSummary) progressSummary.textContent = selected.length ? selected.join(' · ') : '—';

      const host = this.querySelector('[data-summary-list]');
      if (!host) return;
      host.replaceChildren();
      if (!selected.length) {
        const empty = document.createElement('span');
        empty.textContent = '—';
        host.append(empty);
        return;
      }
      selected.forEach((value) => {
        const chip = document.createElement('span');
        chip.textContent = value;
        host.append(chip);
      });
    }

    update() {
      const active = this.steps[this.index];
      this.querySelectorAll('[data-step]').forEach((node) => {
        node.hidden = node.dataset.step !== active;
      });
      const back = this.querySelector('[data-back]');
      const next = this.querySelector('[data-next]');
      if (back) back.hidden = this.index === 0 || active === 'result';
      if (next) next.hidden = active === 'result';
      const progressText = this.querySelector('[data-progress-text]');
      if (progressText) progressText.textContent = String(this.index + 1) + '/' + String(this.steps.length);
      const bar = this.querySelector('[data-progress-bar]');
      if (bar) bar.style.width = (((this.index + 1) / this.steps.length) * 100) + '%';
      this.updateOptions();
      this.updateSummary();
      this.showProjectControls();
      if (active === 'result') this.renderResults();
    }

    renderResults() {
      const unique = this.remoteResults || [];
      const selectionCount = this.selectionCount || 0;

      const host = this.querySelector('[data-results]');
      const copy = this.querySelector('[data-result-copy]');
      if (!host) return;
      host.replaceChildren();

      if (copy) copy.textContent = String(unique.length) + ' ' + (this.dataset.resultCountLabel || '');

      unique.forEach((item) => {
        const article = document.createElement('article');
        article.className = 'leaf-advisor__result-card';

        if (item.row.image) {
          const image = document.createElement('img');
          image.src = item.row.image;
          image.alt = item.row.imageAlt || item.row.title;
          image.loading = 'lazy';
          article.append(image);
        } else {
          const spacer = document.createElement('span');
          spacer.setAttribute('aria-hidden', 'true');
          article.append(spacer);
        }

        const copyNode = document.createElement('div');
        const title = document.createElement('strong');
        title.textContent = item.row.title;
        const meta = document.createElement('span');
        const match = selectionCount ? String(item.matched) + '/' + String(selectionCount) + ' ' + (this.dataset.matchLabel || '') : '';
        meta.textContent = [match, item.row.price].filter(Boolean).join(' · ');
        copyNode.append(title, meta);

        const link = document.createElement('a');
        link.href = item.row.url;
        link.textContent = this.dataset.viewLabel || '';
        article.append(copyNode, link);
        host.append(article);
      });
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["leaf-shop-assistant"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('leaf-shop-assistant')) {
    customElements.define('leaf-shop-assistant', class extends HTMLElement {
      connectedCallback() {
        this.trigger = this.querySelector('[data-assistant-open]');
        this.dialog = this.querySelector('[data-assistant-dialog]');
        this.closeButton = this.querySelector('[data-assistant-close]');
        this.minimizeButton = this.querySelector('[data-assistant-minimize]');
        this.dragHandle = this.querySelector('[data-assistant-drag]');
        this.form = this.querySelector('[data-assistant-form]');
        this.input = this.querySelector('[data-assistant-input]');
        this.submit = this.querySelector('[data-assistant-submit]');
        this.log = this.querySelector('[data-assistant-log]');
        this.voiceButton = this.querySelector('[data-assistant-voice]');
        this.chatAction = this.querySelector('[data-assistant-action-chat]');
        this.voiceAction = this.querySelector('[data-assistant-action-voice]');
        this.voiceStopButton = this.querySelector('[data-assistant-voice-stop]');
        this.voiceStopButton?.addEventListener('click', () => this.stopVoice());
        this.voiceStatus = this.querySelector('[data-assistant-voice-status]');
        this.endpoint = this.dataset.endpoint || '';
        this.storageKey = this.dataset.storageKey || 'leafer-assistant-session-v1';
        this.history = this.restoreHistory();
        this.introduce();

        this.trigger?.addEventListener('click', () => this.open());
        this.chatAction?.addEventListener('click', () => this.open());
        this.voiceAction?.addEventListener('click', () => this.startVoiceConversation());
        this.closeButton?.addEventListener('click', () => this.close());
        this.minimizeButton?.addEventListener('click', () => this.close());
        this.setupDrag();
        this.form?.addEventListener('submit', (event) => this.send(event, false));
        this.setupVoice();
        this.querySelectorAll('[data-assistant-quick]').forEach((button) => {
          if (button.dataset.assistantQuick === 'voice' && !this.recognition && !this.realtimeSupported) button.hidden = true;
          button.addEventListener('click', () => {
            this.open();
            if (button.dataset.assistantQuick === 'voice' && !this.voiceMode) this.startVoice();
          });
        });
        this.restoreVisibleHistory();
        this.querySelectorAll('[data-assistant-suggestion]').forEach((button) => {
          button.addEventListener('click', () => {
            if (!this.input) return;
            this.input.value = button.dataset.assistantSuggestion || '';
            this.input.focus();
          });
        });
        this.addEventListener('keydown', (event) => {
          if (event.key === 'Escape' && this.dialog?.open) this.close();
        });
      }

      disconnectedCallback() {
        window.clearTimeout(this.introTimer);
        window.clearTimeout(this.voiceStatusTimer);
        window.clearTimeout(this.voiceRestartTimer);
        this.stopVoice();
        this.dragEvents?.abort();
        if ('speechSynthesis' in window) window.speechSynthesis.cancel();
      }

      introduce() {
        const key = 'leaf-assistant-introduced-v1';
        try {
          if (sessionStorage.getItem(key)) return;
          sessionStorage.setItem(key, '1');
        } catch {}
        this.classList.add('is-introducing');
        this.introTimer = window.setTimeout(() => this.classList.remove('is-introducing'), 2600);
      }

      restoreHistory() {
        try {
          const parsed = JSON.parse(sessionStorage.getItem(this.storageKey) || '[]');
          return Array.isArray(parsed)
            ? parsed.filter((item) => item && ['user', 'assistant'].includes(item.role) && typeof item.content === 'string').slice(-8)
            : [];
        } catch {
          return [];
        }
      }

      saveHistory() {
        try {
          sessionStorage.setItem(this.storageKey, JSON.stringify(this.history.slice(-8)));
        } catch {}
      }

      restoreVisibleHistory() {
        if (!this.history.length) return;
        this.history.slice(-4).forEach((item) => this.appendMessage(item.role, item.content, [], false));
      }

      setupDrag() {
        if (!this.dragHandle || !this.dialog) return;
        this.dragEvents = new AbortController();
        const options = { signal: this.dragEvents.signal };
        const finish = () => {
          this.drag = null;
          this.dragHandle.classList.remove('is-dragging');
        };
        this.dragHandle.addEventListener('pointerdown', (event) => {
          if (!window.matchMedia('(min-width: 701px)').matches || event.button !== 0 || event.target.closest('button, a')) return;
          const rect = this.dialog.getBoundingClientRect();
          this.drag = { id: event.pointerId, x: event.clientX - rect.left, y: event.clientY - rect.top };
          this.dragHandle.setPointerCapture(event.pointerId);
          this.dragHandle.classList.add('is-dragging');
          event.preventDefault();
        }, options);
        this.dragHandle.addEventListener('pointermove', (event) => {
          if (!this.drag || this.drag.id !== event.pointerId) return;
          this.positionDialog(event.clientX - this.drag.x, event.clientY - this.drag.y);
        }, options);
        this.dragHandle.addEventListener('pointerup', finish, options);
        this.dragHandle.addEventListener('pointercancel', finish, options);
        this.dragHandle.addEventListener('lostpointercapture', finish, options);
        window.addEventListener('resize', () => {
          finish();
          if (!window.matchMedia('(min-width: 701px)').matches) {
            this.dialog.classList.remove('is-positioned');
          } else if (this.dialog.open && this.dialog.classList.contains('is-positioned')) {
            const rect = this.dialog.getBoundingClientRect();
            this.positionDialog(rect.left, rect.top);
          }
        }, options);
      }

      positionDialog(left, top) {
        const rect = this.dialog.getBoundingClientRect();
        const x = Math.max(8, Math.min(left, window.innerWidth - rect.width - 8));
        const y = Math.max(8, Math.min(top, window.innerHeight - rect.height - 8));
        this.dialog.style.setProperty('--assistant-left', x + 'px');
        this.dialog.style.setProperty('--assistant-top', y + 'px');
        this.dialog.classList.add('is-positioned');
      }

      setupVoice() {
        const Recognition = window.SpeechRecognition || window.webkitSpeechRecognition;
        this.realtimeSupported = Boolean(window.RTCPeerConnection && navigator.mediaDevices?.getUserMedia);
        if (this.realtimeSupported) {
          if (this.voiceButton) this.voiceButton.hidden = false;
          if (this.voiceAction) this.voiceAction.hidden = false;
        }
        if (!this.voiceButton) return;
        this.voiceButton.addEventListener('click', () => {
          if (this.voiceMode) this.stopVoice();
          else if (this.dialog?.open) this.startVoice();
        });
        if (!Recognition) return;
        try { this.recognition = new Recognition(); } catch { return; }
        this.voiceButton.hidden = false;
        if (this.voiceAction) this.voiceAction.hidden = false;
        this.recognition.lang = (this.dataset.locale || 'de').startsWith('de') ? 'de-DE' : 'en-US';
        this.recognition.interimResults = true;
        this.recognition.continuous = false;
        this.recognition.maxAlternatives = 1;
        this.updateVoiceButton();
        this.recognition.addEventListener('start', () => {
          if (!this.voiceMode || !this.voiceActive) {
            this.recognition.abort();
            return;
          }
          this.updateVoiceButton();
          if (this.voiceStatus) this.voiceStatus.textContent = (this.dataset.voiceListeningLabel || '') + (this.voiceFallback ? ' ' + (this.dataset.voiceFallback || '') : '');
        });
        this.recognition.addEventListener('end', () => {
          this.voiceActive = false;
          this.updateVoiceButton();
          if (!this.voiceMode && !this.voiceStatusTimer && this.voiceStatus) this.voiceStatus.textContent = '';
          if (this.voiceMode && !this.voiceSubmitted && !this.voiceSending && !this.voiceSpeaking) {
            window.clearTimeout(this.voiceRestartTimer);
            this.voiceRestartTimer = window.setTimeout(() => this.resumeVoice(), 650);
          }
        });
        this.recognition.addEventListener('error', (event) => {
          if (event.error === 'no-speech') return;
          this.voiceError();
        });
        this.recognition.addEventListener('result', (event) => {
          if (!this.voiceMode || !this.voiceActive || this.voiceSubmitted || this.submit?.disabled) return;
          let finalTranscript = '';
          let interimTranscript = '';
          for (let index = event.resultIndex || 0; index < event.results.length; index += 1) {
            const result = event.results[index];
            const transcript = result?.[0]?.transcript?.trim();
            if (!transcript) continue;
            if (result.isFinal) finalTranscript += (finalTranscript ? ' ' : '') + transcript;
            else interimTranscript += (interimTranscript ? ' ' : '') + transcript;
          }
          const transcript = (finalTranscript || interimTranscript).trim();
          if (transcript && this.input) this.input.value = transcript.slice(0, 1200);
          if (finalTranscript && !this.voiceSending) {
            this.voiceSubmitted = true;
            this.voiceSending = true;
            if (this.voiceStatus) this.voiceStatus.textContent = this.dataset.thinking || '';
            this.recognition.stop();
            this.send(null, true).finally(() => {
              this.voiceSending = false;
              this.resumeVoice();
            });
          }
        });
      }

      updateVoiceButton() {
        this.classList.toggle('is-voice-mode', Boolean(this.voiceMode));
        if (this.voiceStopButton) this.voiceStopButton.hidden = !this.voiceMode || Boolean(this.dialog?.open);
        this.voiceButton?.classList.toggle('is-listening', Boolean(this.voiceActive));
        this.voiceButton?.setAttribute('aria-pressed', String(Boolean(this.voiceMode)));
        const label = this.voiceMode ? this.dataset.voiceStopLabel : this.dataset.voiceLabel;
        this.voiceButton?.setAttribute('aria-label', label || '');
        this.voiceButton?.setAttribute('title', label || '');
      }

      startVoiceConversation() {
        if (!this.dialog?.open) this.open(false);
        return this.startVoice();
      }

      async startVoice() {
        if (this.submit?.disabled || this.voiceMode) return;
        if (this.realtimeSupported) {
          const attemptEpoch = (this.voiceEpoch || 0) + 1;
          try { await this.startRealtimeVoice(); return; } catch (error) {
            if (this.voiceEpoch !== attemptEpoch) return;
            this.stopVoice();
            if (!this.recognition) {
              if (this.voiceStatus) this.voiceStatus.textContent = this.dataset.voiceUnavailable || this.dataset.error || '';
              return;
            }
            this.voiceFallback = true;
          }
        }
        if (!this.recognition) return;
        this.voiceFallback = true;
        this.voiceMode = true;
        this.updateVoiceButton();
        const greeting = this.dataset.voiceGreeting || this.dataset.welcome;
        if ('speechSynthesis' in window && greeting && !this.history.length) this.speak(greeting, true);
        else this.resumeVoice();
      }

      async startRealtimeVoice() {
        this.voiceMode = true;
        this.voiceStarting = true;
        const epoch = this.voiceEpoch = (this.voiceEpoch || 0) + 1;
        this.updateVoiceButton();
        if (this.voiceStatus) this.voiceStatus.textContent = this.dataset.voiceConnecting || '';
        const active = () => this.voiceMode && epoch === this.voiceEpoch && this.isConnected;
        const stream = await navigator.mediaDevices.getUserMedia({ audio: { echoCancellation: true, noiseSuppression: true, autoGainControl: true } });
        if (!active()) { stream.getTracks().forEach((track) => track.stop()); throw new DOMException('Stopped', 'AbortError'); }
        this.realtimeStream = stream;
        const peer = this.realtimePeer = new window.RTCPeerConnection();
        const audio = this.realtimeAudio = document.createElement('audio');
        audio.autoplay = true;
        audio.hidden = true;
        audio.setAttribute('playsinline', '');
        this.append(audio);
        peer.ontrack = (event) => {
          if (!active()) return;
          audio.srcObject = event.streams[0];
          audio.play().catch(() => { if (active()) this.voiceError(); });
        };
        stream.getAudioTracks().forEach((track) => peer.addTrack(track, stream));
        const channel = this.realtimeChannel = peer.createDataChannel('oai-events');
        this.realtimeTurn = 0;
        this.realtimeCancelled = new Set();
        this.realtimeCalls = new Set();
        this.realtimePending = null;
        channel.addEventListener('message', (event) => {
          if (!active()) return;
          try { this.handleRealtimeEvent(JSON.parse(event.data), epoch); } catch {}
        });
        channel.addEventListener('open', () => {
          if (!active()) return;
          this.voiceStarting = false;
          window.clearTimeout(this.realtimeConnectTimer);
          this.voiceActive = true;
          this.updateVoiceButton();
          this.realtimeListening();
          if (!this.history.length) this.sendRealtime({ type: 'response.create', response: { instructions: 'Briefly say this greeting naturally, then wait for the user: ' + this.dataset.welcome } });
        });
        peer.onconnectionstatechange = () => {
          if (active() && ['failed', 'closed'].includes(peer.connectionState)) this.voiceError();
        };
        const offer = await peer.createOffer();
        if (!active()) throw new DOMException('Stopped', 'AbortError');
        await peer.setLocalDescription(offer);
        this.realtimeRequest = new AbortController();
        this.realtimeConnectTimer = window.setTimeout(() => this.realtimeRequest?.abort(), 20000);
        const response = await fetch(this.endpoint, {
          method: 'POST', signal: this.realtimeRequest.signal,
          headers: { 'content-type': 'application/json' },
          body: JSON.stringify({ action: 'voice_connect', sdp: offer.sdp, history: this.history.slice(-6), locale: this.dataset.locale || 'de', path: this.dataset.path || location.pathname })
        });
        const payload = await response.json();
        if (!active()) throw new DOMException('Stopped', 'AbortError');
        if (!response.ok || typeof payload.sdp !== 'string') throw new Error('voice_unavailable');
        await peer.setRemoteDescription({ type: 'answer', sdp: payload.sdp });
        // Keep the connection deadline until the data channel opens.
        window.clearTimeout(this.realtimeConnectTimer);
        this.realtimeConnectTimer = window.setTimeout(() => { if (active() && this.voiceStarting) this.voiceError(); }, 15000);
      }

      sendRealtime(event) {
        if (this.voiceMode && this.realtimeChannel?.readyState === 'open') this.realtimeChannel.send(JSON.stringify(event));
      }

      realtimeListening() {
        if (this.voiceStatus) this.voiceStatus.textContent = this.dataset.voiceListeningLabel || '';
        window.clearTimeout(this.realtimeIdleTimer);
        const epoch = this.voiceEpoch;
        this.realtimeIdleTimer = window.setTimeout(() => {
          if (!this.voiceMode || this.voiceEpoch !== epoch) return;
          this.stopVoice();
          if (this.voiceStatus) this.voiceStatus.textContent = this.dataset.voicePaused || '';
        }, 180000);
      }

      handleRealtimeEvent(event, epoch) {
        if (!this.voiceMode || epoch !== this.voiceEpoch) return;
        if (event.type === 'input_audio_buffer.speech_started') {
          window.clearTimeout(this.realtimeIdleTimer);
          this.realtimeTurn++;
          if (this.realtimeResponse) this.realtimeCancelled.add(this.realtimeResponse);
          this.realtimePending = null;
          this.realtimeResponse = null;
          this.voiceSpeaking = false;
          this.voiceActive = true;
          if (this.voiceStatus) this.voiceStatus.textContent = this.dataset.voiceListeningLabel || '';
        } else if (event.type === 'output_audio_buffer.started') {
          if (this.realtimeCancelled.has(event.response_id)) return;
          this.realtimeResponse = event.response_id;
          this.voiceSpeaking = true;
          this.voiceActive = false;
          window.clearTimeout(this.realtimeIdleTimer);
          if (this.voiceStatus) this.voiceStatus.textContent = (this.voiceFallback ? this.dataset.voiceFallback : this.dataset.voiceSpeakingLabel) || '';
        } else if (event.type === 'output_audio_buffer.cleared') {
          if (this.realtimeResponse && this.realtimeResponse !== event.response_id) return;
          if (event.response_id) this.realtimeCancelled.add(event.response_id);
          this.realtimePending = null;
          this.voiceSpeaking = false;
          this.voiceActive = true;
        } else if (event.type === 'conversation.item.input_audio_transcription.completed') {
          this.recordRealtimeMessage('user', event.transcript);
        } else if (event.type === 'response.output_audio_transcript.done' && !this.realtimeCancelled.has(event.response_id)) {
          this.realtimePending = { id: event.response_id, text: event.transcript };
        } else if (event.type === 'output_audio_buffer.stopped') {
          if (this.realtimeResponse && this.realtimeResponse !== event.response_id) return;
          if (this.realtimePending?.id === event.response_id && !this.realtimeCancelled.has(event.response_id)) this.recordRealtimeMessage('assistant', this.realtimePending.text);
          this.realtimePending = null;
          this.realtimeResponse = null;
          this.voiceSpeaking = false;
          this.voiceActive = true;
          this.realtimeListening();
        } else if (event.type === 'response.done' && event.response?.status === 'completed') {
          const calls = (event.response.output || []).filter((item) => item.type === 'function_call' && item.status === 'completed' && item.name === 'lookup_leaf_knowledge');
          if (calls.length) this.realtimeLookup(calls, epoch);
        } else if (event.type === 'error') {
          this.voiceError();
        }
        this.updateVoiceButton();
      }

      recordRealtimeMessage(role, text) {
        if (typeof text !== 'string' || !text.trim()) return;
        const content = text.trim().slice(0, 1600);
        this.appendMessage(role, content, [], false);
        this.history.push({ role, content });
        this.saveHistory();
      }

      async realtimeLookup(calls, epoch) {
        const turn = this.realtimeTurn;
        for (const call of calls) {
          if (this.realtimeCalls.has(call.call_id)) continue;
          this.realtimeCalls.add(call.call_id);
          let output = { error: 'knowledge_unavailable' };
          try {
            const args = JSON.parse(call.arguments);
            const response = await fetch(this.endpoint, { method: 'POST', headers: { 'content-type': 'application/json' }, signal: AbortSignal.timeout(15000), body: JSON.stringify({ action: 'knowledge_lookup', message: String(args.query || '').slice(0, 1600) }) });
            if (response.ok) output = await response.json();
          } catch {}
          if (!this.voiceMode || epoch !== this.voiceEpoch) return;
          this.sendRealtime({ type: 'conversation.item.create', item: { type: 'function_call_output', call_id: call.call_id, output: JSON.stringify(output) } });
        }
        // A new utterance owns the next response; a late lookup must not speak over it.
        if (this.voiceMode && epoch === this.voiceEpoch && turn === this.realtimeTurn) this.sendRealtime({ type: 'response.create' });
      }

      cleanupRealtime() {
        window.clearTimeout(this.realtimeConnectTimer);
        window.clearTimeout(this.realtimeIdleTimer);
        this.realtimeRequest?.abort();
        if (this.realtimePeer) this.realtimePeer.onconnectionstatechange = null;
        this.realtimeChannel?.close();
        this.realtimePeer?.close();
        this.realtimeStream?.getTracks().forEach((track) => track.stop());
        if (this.realtimeAudio) { this.realtimeAudio.pause(); this.realtimeAudio.srcObject = null; this.realtimeAudio.remove(); }
        this.realtimePeer = null;
        this.realtimeChannel = null;
        this.realtimeStream = null;
        this.realtimeAudio = null;
        this.voiceStarting = false;
      }

      resumeVoice() {
        if (this.realtimePeer || this.voiceStarting) return;
        if (!this.voiceMode || !this.isConnected || this.voiceActive || this.voiceSpeaking || this.voiceSending || this.submit?.disabled) return;
        window.clearTimeout(this.voiceRestartTimer);
        window.clearTimeout(this.voiceStatusTimer);
        this.voiceStatusTimer = null;
        this.voiceActive = true;
        this.voiceSubmitted = false;
        this.updateVoiceButton();
        if (this.voiceStatus) this.voiceStatus.textContent = (this.dataset.voiceListeningLabel || '') + (this.voiceFallback ? ' ' + (this.dataset.voiceFallback || '') : '');
        try { this.recognition.start(); } catch { this.voiceError(); }
      }

      voiceError() {
        if (!this.voiceMode) return;
        this.stopVoice();
        if (this.voiceStatus) {
          this.voiceStatus.textContent = this.dataset.error || '';
          this.voiceStatusTimer = window.setTimeout(() => {
            this.voiceStatusTimer = null;
            if (this.voiceStatus) this.voiceStatus.textContent = '';
          }, 3500);
        }
      }

      stopVoice() {
        this.cleanupRealtime();
        this.voiceFallback = false;
        this.voiceMode = false;
        this.voiceActive = false;
        this.voiceSpeaking = false;
        this.voiceSubmitted = true;
        this.voiceEpoch = (this.voiceEpoch || 0) + 1;
        window.clearTimeout(this.voiceRestartTimer);
        window.clearTimeout(this.voiceStatusTimer);
        this.voiceStatusTimer = null;
        if (this.voiceStatus) this.voiceStatus.textContent = '';
        this.updateVoiceButton();
        this.recognition?.abort();
        if ('speechSynthesis' in window) window.speechSynthesis.cancel();
      }

      preferredVoice(lang) {
        if (!('speechSynthesis' in window)) return null;
        const prefix = String(lang || '').toLowerCase().split('-')[0];
        const voices = window.speechSynthesis.getVoices().filter((voice) => String(voice.lang || '').toLowerCase().startsWith(prefix));
        if (!voices.length) return null;
        const score = (voice) => {
          const name = String(voice.name || '').toLowerCase();
          return (/(natural|premium|enhanced|google|microsoft)/.test(name) ? 4 : 0)
            + (voice.localService ? 2 : 0)
            + (String(voice.lang || '').toLowerCase() === String(lang || '').toLowerCase() ? 1 : 0);
        };
        return voices.sort((a, b) => score(b) - score(a))[0] || null;
      }

      speak(text, continueVoice = false) {
        if (!continueVoice && this.voiceMode) this.stopVoice();
        if (!('speechSynthesis' in window) || !text) return;
        window.speechSynthesis.cancel();
        const epoch = this.voiceEpoch || 0;
        const spokenText = String(text)
          .replace(/https?:\/\/\S+/gi, '')
          .replace(/[*#_`]+/g, '')
          .replace(/\s+/g, ' ')
          .trim();
        if (!spokenText) return;
        const utterance = new SpeechSynthesisUtterance(spokenText);
        utterance.lang = (this.dataset.locale || 'de').startsWith('de') ? 'de-DE' : 'en-US';
        utterance.rate = .78;
        utterance.pitch = 1;
        utterance.volume = 1;
        const voice = this.preferredVoice(utterance.lang);
        if (voice) utterance.voice = voice;
        if (continueVoice) {
          this.voiceSpeaking = true;
          if (this.voiceStatus) this.voiceStatus.textContent = (this.voiceFallback ? this.dataset.voiceFallback : this.dataset.voiceSpeakingLabel) || '';
          utterance.onend = () => {
            if (epoch !== (this.voiceEpoch || 0)) return;
            this.voiceSpeaking = false;
            this.voiceRestartTimer = window.setTimeout(() => this.resumeVoice(), 400);
          };
          utterance.onerror = () => {
            if (epoch === (this.voiceEpoch || 0)) this.voiceError();
          };
        }
        try { window.speechSynthesis.speak(utterance); } catch { this.voiceError(); }
      }

      open(focusInput = true) {
        window.clearTimeout(this.introTimer);
        this.classList.remove('is-introducing');
        if (!this.dialog?.open) this.dialog?.show();
        this.classList.add('is-open');
        this.trigger?.setAttribute('aria-expanded', 'true');
        this.updateVoiceButton();
        if (focusInput && !this.voiceMode) {
          window.setTimeout(() => { if (this.dialog?.open) this.input?.focus(); }, 20);
        }
      }

      close() {
        if (this.dialog?.open) this.dialog.close();
        this.classList.remove('is-open');
        this.trigger?.setAttribute('aria-expanded', 'false');
        this.updateVoiceButton();
        this.trigger?.focus();
      }

      appendMessage(role, text, links = [], allowSpeech = true) {
        if (!this.log) return;
        const wrapper = document.createElement('div');
        wrapper.className = 'leaf-shop-assistant__message' + (role === 'user' ? ' leaf-shop-assistant__message--user' : '');
        const label = document.createElement('strong');
        label.textContent = role === 'user' ? (this.dataset.userLabel || '') : (this.dataset.assistantLabel || '');
        const body = document.createElement('p');
        body.textContent = text;
        wrapper.append(label, body);

        if (Array.isArray(links) && links.length) {
          const list = document.createElement('div');
          list.className = 'leaf-shop-assistant__links';
          links.slice(0, 3).forEach((link) => {
            if (!link || typeof link.href !== 'string') return;
            let target;
            try { target = new URL(link.href, location.origin); } catch { return; }
            if (
              target.origin !== location.origin
              || target.search
              || target.hash
              || !/^\/(?:en\/)?products\/[^/?#]+$/i.test(target.pathname)
            ) return;
            const anchor = document.createElement('a');
            anchor.href = target.pathname;
            anchor.textContent = String(link.label || target.pathname);
            list.append(anchor);
          });
          if (list.childElementCount) wrapper.append(list);
        }

        if (role === 'assistant' && allowSpeech && 'speechSynthesis' in window) {
          const speak = document.createElement('button');
          speak.type = 'button';
          speak.className = 'leaf-shop-assistant__speak';
          speak.textContent = this.dataset.speakLabel || '';
          speak.addEventListener('click', () => this.speak(text));
          wrapper.append(speak);
        }

        this.log.append(wrapper);
        this.log.scrollTop = this.log.scrollHeight;
      }

      async send(event, speakResponse = false) {
        event?.preventDefault();
        const message = this.input?.value.trim() || '';
        if (!message || !this.endpoint || this.submit?.disabled) return;

        if (!speakResponse) this.stopVoice();
        const voiceEpoch = this.voiceEpoch || 0;
        const priorHistory = this.history.slice(-6);
        const visibleMessage = message;
        this.appendMessage('user', visibleMessage);
        if (message) {
          this.history.push({ role: 'user', content: message });
          this.saveHistory();
        }
        this.input.value = '';
        this.submit.disabled = true;
        this.input.disabled = true;
        if (this.voiceButton) this.voiceButton.disabled = !this.voiceMode;

        const thinking = document.createElement('div');
        thinking.className = 'leaf-shop-assistant__message';
        const thinkingBody = document.createElement('p');
        thinkingBody.textContent = this.dataset.thinking || '';
        thinking.append(thinkingBody);
        this.log.append(thinking);
        this.log.scrollTop = this.log.scrollHeight;

        try {
          const response = await fetch(this.endpoint, {
            method: 'POST',
            headers: { 'content-type': 'application/json' },
            body: JSON.stringify({
              message,
              history: priorHistory,
              locale: this.dataset.locale || 'de',
              path: this.dataset.path || location.pathname,
              voice: Boolean(speakResponse)
            })
          });
          const payload = await response.json().catch(() => ({}));
          thinking.remove();
          if (!response.ok || typeof payload.answer !== 'string') throw new Error('assistant_unavailable');

          this.appendMessage('assistant', payload.answer, payload.links);
          const spoken = typeof payload.speech === 'string' && payload.speech ? payload.speech : payload.answer;
          if (speakResponse && this.voiceMode && this.isConnected && voiceEpoch === (this.voiceEpoch || 0)) this.speak(spoken, this.voiceMode);
          this.history.push({ role: 'assistant', content: payload.answer });
          this.saveHistory();
        } catch {
          thinking.remove();
          this.stopVoice();
          this.appendMessage('assistant', this.dataset.error || '');
        } finally {
          this.submit.disabled = false;
          this.input.disabled = false;
          if (this.voiceButton) this.voiceButton.disabled = false;
          if (this.dialog?.open && this.isConnected && !this.voiceMode) this.input.focus();
        }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
